import React, { useContext } from 'react';
import { Button, Card } from '@mui/material';
import useIsDesktop from 'hooks/useIsDesktop';
import { CartContext } from 'constants/contexts';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined';
import { env } from 'constants';

function Footer({ schedulingRequired, onOpenScheduling }) {
  const { items, openCart } = useContext(CartContext);
  const isDesktop = useIsDesktop();
  if (isDesktop || items.length === 0) {
    return null;
  }

  if (!isDesktop && env.IS_CATERING) {
    return null;
  }

  function handleClick() {
    if (schedulingRequired) {
      onOpenScheduling();
      return;
    }
    openCart();
  }
  return (
    <Card
      square
      variant="outlined"
      sx={{
        position: 'fixed',
        bottom: 0,
        paddingBottom: 'calc(8px + var(--gap-bottom))',
        left: 0,
        right: 0,
        p: 1,
        zIndex: 2,
        borderWidth: 0,
        borderTopWidth: 1,
      }}
    >
      <Button
        variant="contained"
        startIcon={schedulingRequired ? null : <ShoppingCartIcon />}
        fullWidth
        sx={(theme) => ({ height: 50, zIndex: theme.zIndex.appBar })}
        onClick={handleClick}
      >
        {
          schedulingRequired ? 'Schedule for later' : `View cart (${items.length})`
        }
      </Button>
    </Card>
  );
}

export default Footer;
